import { render, staticRenderFns } from "./StandPaginationTable.vue?vue&type=template&id=0a315572"
import script from "./StandPaginationTable.vue?vue&type=script&lang=js"
export * from "./StandPaginationTable.vue?vue&type=script&lang=js"
import style0 from "./StandPaginationTable.vue?vue&type=style&index=0&id=0a315572&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a315572')) {
      api.createRecord('0a315572', component.options)
    } else {
      api.reload('0a315572', component.options)
    }
    module.hot.accept("./StandPaginationTable.vue?vue&type=template&id=0a315572", function () {
      api.rerender('0a315572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/standard-pagination-table/StandPaginationTable.vue"
export default component.exports